//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "character",
    data() {
        return {}
    },
    methods: {},
    created() {
    }
}
